import { isGeneratorFunction, isAsyncFunctionWithoutTransform, createServerAsyncComponentWrapper, createServerSyncComponentWrapper, } from './component-shared.js';
export default function component(fn) {
    if (isAsyncFunctionWithoutTransform(fn)) {
        throw new Error('signalium: `component(async (props) => { await ... })` requires the Signalium Babel preset (async transform).');
    }
    if (isGeneratorFunction(fn)) {
        return createServerAsyncComponentWrapper(fn);
    }
    return createServerSyncComponentWrapper(fn);
}
